import { EstimatedTradeCostComparisonWidgetSettingsState } from 'widgets/estimatedTradeCost/widget-comparison/components/settings/EstimatedTradeCostComparisonWidgetSettingsState';
import {
    EstimatedTradeCostOptimization,
    toOptimizationUid,
} from 'widgets/estimatedTradeCost/widget/store/EstimatedTradeCostConfigState';
import { StrikeBenchmark } from 'widgets/estimatedTradeCost/components/options';

type IsValidResponse = {
    isValid: boolean;
    duplicateIndexes: number[];
};
export function isValid(
    state: EstimatedTradeCostComparisonWidgetSettingsState
): IsValidResponse {
    const response: IsValidResponse = { isValid: true, duplicateIndexes: [] };
    const uids: string[] = [];

    for (let index = 0; index < state.config.optimizations.length; index++) {
        const opt = state.config.optimizations[index];
        const isValid = isOptimizationValid(opt);
        if (!isValid) {
            response.isValid = false;
        }
        const uid = toOptimizationUid(opt);

        if (uids.indexOf(uid) > -1) {
            if (isValid) {
                response.isValid = false;
                response.duplicateIndexes.push(index);
            }
        } else {
            uids.push(uid);
        }
    }

    return response;
}

export const isBenchmarkMissing = (o: EstimatedTradeCostOptimization) =>
    !o.benchmark;
export const isProfileMissing = (o: EstimatedTradeCostOptimization) =>
    !o.profile;
export const isStrikeTimeMissing = (o: EstimatedTradeCostOptimization) =>
    o.benchmark === StrikeBenchmark && !o.strikeTime;

function isOptimizationValid(o: EstimatedTradeCostOptimization) {
    return !(
        isBenchmarkMissing(o) ||
        isProfileMissing(o) ||
        isStrikeTimeMissing(o)
    );
}
